import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { createRoot } from "react-dom/client";
import superjson from "superjson";
import App from "./App";
import { convex } from "./lib/convex";
import { trpc } from "./lib/trpc";
import "./index.css";

/**
 * App root.
 *
 * Auth/state is now managed by Convex (real-time subscriptions + @convex-dev/auth).
 *
 * F20d (2026-05-13): tRPC client + QueryClient providers RESTAURADOS como stubs.
 * Components legacy (DashboardLayout, AccountSwitcher, NotificationBadge, etc)
 * ainda usam `trpc.X.Y.useQuery()` em ~21 callsites. Sem TRPCProvider, app
 * crasha com "Unable to find tRPC Context". Mantemos providers SEM backend
 * Express — chamadas vão pra /api/trpc/* que retorna 404 e useQuery fica
 * em isLoading=true; pages renderizam placeholders. Próxima fase F5+ remove
 * todos os callsites tRPC e remove esse setup.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      // Sem Express → todas as tRPC queries vão falhar. Não retry pra evitar loop.
    },
    mutations: {
      retry: false,
    },
  },
});

const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: "/api/trpc",
      transformer: superjson,
    }),
  ],
});

createRoot(document.getElementById("root")!).render(
  <ConvexAuthProvider client={convex}>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </trpc.Provider>
  </ConvexAuthProvider>
);
